module.exports = __webpack_public_path__ + "img/logo_row_white_kr.1fbb2ba0.svg";